import {EnumLanguage} from "../EnumLanguage";

export const UXRegistration = {
    registrationSuccess: {
        header: {
            [EnumLanguage.ru]: 'Регистрация почти завершена! :)',
            [EnumLanguage.en]: 'Registration is almost complete!',
            [EnumLanguage.cn]:  '注册即将完成'
        },
        text: {
            [EnumLanguage.ru]: 'Осталось только подтвердить аккаунт на Вашей электронной почте!',
            [EnumLanguage.en]: 'It remains only to confirm the account on your e-mail!',
            [EnumLanguage.cn]:  '它只是为了确认您电子邮件中的帐户'
        }
    }
}